var map = {
	"./baac.svg": 627,
	"./bay.svg": 628,
	"./bbl.svg": 629,
	"./bnp.svg": 630,
	"./boa.svg": 631,
	"./cacib.svg": 632,
	"./cimb.svg": 633,
	"./citi.svg": 634,
	"./db.svg": 635,
	"./ghb.svg": 636,
	"./gsb.svg": 637,
	"./hsbc.svg": 638,
	"./ibank.svg": 639,
	"./icbc.svg": 640,
	"./jpm.svg": 641,
	"./kbank.svg": 642,
	"./kk.svg": 643,
	"./ktb.svg": 644,
	"./lhb.svg": 645,
	"./mb.svg": 646,
	"./mega.svg": 647,
	"./mufg.svg": 648,
	"./rbs.svg": 649,
	"./sc.svg": 650,
	"./scb.svg": 651,
	"./smbc.svg": 652,
	"./tbank.svg": 653,
	"./tcrb.svg": 654,
	"./tisco.svg": 655,
	"./tmb.svg": 656,
	"./uob.svg": 657
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 79
// module chunks = 1